export default __webpack_public_path__ + "static/media/Mark-6-HUD-Label.505b706a.jpg";